import makeStyles from "@mui/styles/makeStyles";
import { SemiBold, Regular, remCalc } from "../../utils";

export const useStyles = makeStyles((theme) => ({
  trigger_box: {
    cursor: "pointer",
    height: ({ iconOnly }) => (iconOnly ? "34px" : "39px"),
    padding: ({ iconOnly }) => (iconOnly ? "4px 6px" : "4px 8px"),
    display: "flex",
    alignItems: "center",
    border: "1px solid #CACFDB",
    borderRadius: "100px",
    columnGap: "6px",
  },
  trigger_text: {
    fontSize: "0.875rem",
    fontFamily: SemiBold,
    color: theme.typography.color.primary,
  },
  menu: {
    marginTop: "10px",
    "& .MuiPopover-paper": {
      maxHeight: "250px",
      minWidth: "200px",
      padding: "8px 16px",
      boxShadow: "0 0px 8px -4px #f2f3f5",
      border: "1px solid #f2f3f5",
      borderRadius: "5px",
    },
  },
  selected_item: {
    border: "1px solid #5078E1",
    borderRadius: theme.palette.borderRadius,
    padding: "12px 5px",
    backgroundColor: "#F1F7FF",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  unselected_item: {
    borderRadius: theme.palette.borderRadius,
    padding: "12px 5px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  selected_item_text: {
    fontSize: remCalc(14),
    fontFamily: SemiBold,
    color: theme.typography.color.selected_1,
  },
  unselected_item_text: {
    fontSize: remCalc(14),
    fontFamily: Regular,
    color: theme.typography.color.primary,
  },
}));
